import { render, staticRenderFns } from "./emergencyProfessor.vue?vue&type=template&id=b341fec4&scoped=true&"
import script from "./emergencyProfessor.vue?vue&type=script&lang=js&"
export * from "./emergencyProfessor.vue?vue&type=script&lang=js&"
import style0 from "./emergencyProfessor.vue?vue&type=style&index=0&id=b341fec4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b341fec4",
  null
  
)

export default component.exports